import create from 'zustand'
import fetch from '~/common/fetch'
import { VndlyAlert } from '~/common/VndlyAlert'

const LIMIT = 5
const defaultUrl = `/api/v2/notifications/notifications/?limit=${LIMIT}`
const headersToPreventCaching = { Pragma: 'no-cache', 'Cache-Control': 'no-store' }

const api = {
  load: () => fetch.get(`${defaultUrl}&is_viewed=false`, { headers: headersToPreventCaching }),
  getLink: link => fetch.get(link, { headers: headersToPreventCaching }),
  search: (onlyUnread, queryString) => {
    const qs = queryString ? `&query=${queryString}` : ''
    return fetch.get(`${defaultUrl}${onlyUnread ? '&is_viewed=false' : ''}${qs}`, { headers: headersToPreventCaching })
  }
}

export const useNotificationsStore = create((set, get) => ({
  error: false,
  loading: true,
  nextLink: null,
  prevLink: null,
  totalResults: 0,
  page: 1,
  totalPages: 1,
  notifications: [],

  onlyUnread: true,
  queryString: '',

  actions: {
    async init() {
      try {
        const resp = await api.load()
        set({
          error: false,
          loading: false,
          nextLink: resp.next_link,
          prevLink: resp.previous_link,
          notifications: resp.results,
          totalResults: resp.count,
          totalPages: resp.count > 0 ? Math.ceil(resp.count / LIMIT) : 0
        })
      } catch {
        set({ error: true })
      }
    },
    async nextPage() {
      if (!get().nextLink) {
        return
      }
      const resp = await api.getLink(get().nextLink)
      set({
        page: get().page + 1,
        loading: false,
        nextLink: resp.next_link,
        prevLink: resp.previous_link,
        notifications: resp.results,
        totalResults: resp.count,
        totalPages: resp.count > 0 ? Math.ceil(resp.count / LIMIT) : 0
      })
    },
    async prevPage() {
      if (!get().prevLink) {
        return
      }
      const resp = await api.getLink(get().prevLink)
      set({
        page: get().page - 1,
        loading: false,
        nextLink: resp.next_link,
        prevLink: resp.previous_link,
        notifications: resp.results,
        totalResults: resp.count,
        totalPages: resp.count > 0 ? Math.ceil(resp.count / LIMIT) : 0
      })
    },
    async setOnlyUnread(ur) {
      const resp = await api.search(ur, get().queryString)
      set({
        page: 1,
        onlyUnread: ur,
        loading: false,
        nextLink: resp.next_link,
        prevLink: resp.previous_link,
        notifications: resp.results,
        totalResults: resp.count,
        totalPages: resp.count > 0 ? Math.ceil(resp.count / LIMIT) : 0
      })
    },
    async setQueryString(qs) {
      const resp = await api.search(get().onlyUnread, qs)
      set({
        page: 1,
        queryString: qs,
        loading: false,
        nextLink: resp.next_link,
        prevLink: resp.previous_link,
        notifications: resp.results,
        totalResults: resp.count,
        totalPages: resp.count > 0 ? Math.ceil(resp.count / LIMIT) : 0
      })
    },
    async markAllRead() {
      const confirm = await VndlyAlert.confirm.question.fire('Mark all notifications as read?')
      if (confirm.value) {
        await fetch.post('/api/v2/notifications/notifications/mark_all_read/')
        try {
          const resp = await api.load()
          set({
            error: false,
            page: 1,
            loading: false,
            nextLink: resp.next_link,
            prevLink: resp.previous_link,
            notifications: resp.results,
            totalResults: resp.count,
            totalPages: resp.count > 0 ? Math.ceil(resp.count / LIMIT) : 0
          })
        } catch {
          set({ error: true })
        }
        VndlyAlert.toast.success.fire('All notifications marked as read!')
        return Promise.resolve()
      }
      return Promise.reject()
    }
  }
}))
